/**
 * Componente de orden superior (HOC) para proteger rutas privadas.
 * Verifica la autenticación mediante el token y valida los permisos por rol (RBAC).
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes/vistas que se desean proteger.
 * @param {string[]} [props.allowedRoles] - Lista de roles permitidos para acceder a la ruta.
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('role');

    // 1. Verificar si el usuario está autenticado mediante la existencia de un token
    if (!token) {
        // Redirigir al inicio de sesión si no hay token, conservando el estado de la ruta intentada
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 2. Verificar el Control de Acceso Basado en Roles (RBAC)
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Redirigir al inicio o a una página de acceso denegado si el rol no tiene privilegios
        return <Navigate to="/" replace />;
    }

    // Si está autenticado y posee el rol adecuado, renderizar el contenido protegido
    return children;
};

export default ProtectedRoute;
